import { render, staticRenderFns } from "./ruitian-news.vue?vue&type=template&id=de32c7c6&scoped=true"
import script from "./ruitian-news.vue?vue&type=script&lang=js"
export * from "./ruitian-news.vue?vue&type=script&lang=js"
import style0 from "./ruitian-news.vue?vue&type=style&index=0&id=de32c7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de32c7c6",
  null
  
)

export default component.exports